module.exports = "/assets/data/8d5d3e4a6117debec487e7dbd94f44fd-M50.data.json";